module.exports = __webpack_public_path__ + "static/media/weight.b6afb8c0.svg";